import { createAxiosClient } from "@ntg/component-library/utilities";
import { ICItemStatusEntry } from "../../declarations/CItemStatusEntry";
import { useQuery } from "@tanstack/react-query";

const getCItemStatusList = async (
    mItemID: number,
): Promise<ICItemStatusEntry[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<ICItemStatusEntry[]>(
        `/ManufacturingSearch/GetCItemStatusList/${mItemID}`,
    );
    return response.data;
};

export const useGetCItemStatusList = (mItemID: number) =>
    useQuery<ICItemStatusEntry[]>({
        enabled: mItemID > 0,
        queryFn: () => getCItemStatusList(mItemID),
        queryKey: ["GetCItemStatusList", mItemID],
        refetchOnWindowFocus: false,
        retry: false,
        select: (data) => data ?? [],
    });
